
import { Component, inject } from '@angular/core';
import {RouterModule} from '@angular/router';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {ButtonModule} from 'primeng/button';
import {LogoComponent} from '../logo/logo.component';

@Component({
  selector: 'app-login-info',
  templateUrl: './login-info.component.html',
  styleUrls: ['./login-info.component.scss'],
  imports: [RouterModule, ButtonModule, LogoComponent, TranslateModule],
})
export class LoginInfoComponent {
  private readonly translate = inject(TranslateService);


  redirectToWhyMedicover(): void {
    window.open(this.translate.instant('Common.WhyMedicover'), '_blank');
  }
}
